import { useTheme } from 'styled-components'

import BaseBtn from './BaseBtn'

const Btn = (props) => {
  const theme = useTheme()
  return (
    <BaseBtn
      {...props}
      color={theme.color_level.grey.medium}
      backgroundColor={theme.color.white}
      border={theme.color_level.grey.medium}
    />
  )
}

export default Btn
